var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "LNBContainer"
  }, [_c('article', {
    ref: "LNB",
    staticClass: "LNB"
  }, [_c('AccordionList')], 1), _c('TagNameBalloon'), _c('TagConTextMenu')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }